import { inject, Injectable } from '@angular/core';
import { Observable, of, shareReplay, throwError } from 'rxjs';
import { Profile } from '@core/profile';
import { AuthService } from '@core/auth';
import { WINDOW } from '@pin-up-global/common';
import { decodeJwt } from '@shared/utils';

@Injectable({
  providedIn: 'root',
})
export class ProfileService {
  #authService = inject(AuthService);
  #window = inject(WINDOW);

  #profile$ = this.#getProfile().pipe(
    shareReplay(1),
  );

  profile$: Observable<Profile> = this.#profile$;

  #getProfile(): Observable<Profile> {
    const token = this.#authService.getAccessToken();

    if (!token) {
      return throwError(() => 'No token found');
    }

    try {
      const profile = decodeJwt<Record<keyof Profile, string>>(token, this.#window);
      return of(profile);
    } catch (error) {
      return throwError(() => 'Invalid token');
    }
  }
}
